import { render, staticRenderFns } from "./EspeciesTabManejo.vue?vue&type=template&id=874e2208&"
import script from "./EspeciesTabManejo.vue?vue&type=script&lang=js&"
export * from "./EspeciesTabManejo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports